
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 32 32"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M16 2.375l.906 2.031 3.25 7.313 7.938.813 2.25.25-1.688 1.5-5.906 5.344 1.656 7.813.469 2.188-1.969-1.125L16 24.533l-6.906 3.969-1.938 1.125h-.031l.469-2.188 1.656-7.813-5.906-5.344-1.688-1.5 2.25-.25 7.938-.813 3.25-7.313zm0 4.906v14.938l.5.281 5.469 3.156-1.313-6.188-.125-.563.438-.375 4.719-4.25-6.875-.719-.25-.5z"}})])
          )
        }
      }
    